<template>
  <div class="history">
    <p>Payroll History</p>
    <div class="history__div">
      <div class="history__div--loader" v-if="loader">
        <PageLoader />
      </div>

      <div class="history__div--content" v-else>
        <div v-if="history.length < 1">
          <div class="history__div--content-filter">
            <div>
              <div class="history__div--content-filter-label">
                <span>Filter by Month:</span>
              </div>
              <div class="filterBtnCover">
                <div class="history__div--content-filter-input">
                  <select class="filterSelect" v-model="month">
                    <option value="">Select Month</option>
                    <option value="1">January</option>
                    <option value="2">Febuary</option>
                    <option value="3">March</option>
                    <option value="4">April</option>
                    <option value="5">May</option>
                    <option value="6">June</option>
                    <option value="7">July</option>
                    <option value="8">August</option>
                    <option value="9">September</option>
                    <option value="10">October</option>
                    <option value="11">November</option>
                    <option value="12">December</option>
                  </select>
                </div>
                <div class="filterBtn" @click="getMonth">filter</div>
              </div>
            </div>
            <div>
              <div class="history__div--content-filter-label">
                <span>Filter by Status:</span>
              </div>
              <div class="filterBtnCover">
                <div class="history__div--content-filter-input">
                  <select class="filterSelect" v-model="filter">
                    <option value="all">All</option>
                    <option value="SUCCESS">successful</option>
                    <option value="PENDING">Pending</option>
                    <option value="PROCESSING">Processing</option>
                    <option value="CANCELLED">Cancelled</option>
                    <option value="FAILED">Failed</option>
                    <option value="PARTIAL">Partial</option>
                  </select>
                </div>
                <div class="filterBtn" @click="getFilter">filter</div>
              </div>
            </div>
          </div>
          <EmptyContent title="No payroll available" />
        </div>
        <div v-else>
          <div class="history__div--content-filter">
            <div>
              <div class="history__div--content-filter-label">
                <span>Filter by Month:</span>
              </div>
              <div class="filterBtnCover">
                <div class="history__div--content-filter-input">
                  <select class="filterSelect" v-model="month">
                    <option value="">Select Month</option>
                    <option value="1">January</option>
                    <option value="2">Febuary</option>
                    <option value="3">March</option>
                    <option value="4">April</option>
                    <option value="5">May</option>
                    <option value="6">June</option>
                    <option value="7">July</option>
                    <option value="8">August</option>
                    <option value="9">September</option>
                    <option value="10">October</option>
                    <option value="11">November</option>
                    <option value="12">December</option>
                  </select>
                </div>
                <div class="filterBtn" @click="getMonth">filter</div>
              </div>
            </div>
            <div>
              <div class="history__div--content-filter-label">
                <span>Filter by Status:</span>
              </div>
              <div class="filterBtnCover">
                <div class="history__div--content-filter-input">
                  <select class="filterSelect" v-model="filter">
                    <option value="all">All</option>
                    <option value="SUCCESS">successful</option>
                    <option value="PENDING">Pending</option>
                    <option value="PROCESSING">Processing</option>
                    <option value="CANCELLED">Cancelled</option>
                    <option value="FAILED">Failed</option>
                    <option value="PARTIAL">Partial</option>
                  </select>
                </div>
                <div class="filterBtn" @click="getFilter">filter</div>
              </div>
            </div>
          </div>

          <div class="table-form">
            <Modal
              :showModal="modalVisible"
              :title="modalTitle"
              :content="modalContent"
              @close="closeModalVisibility"
            />
            <table class="table">
              <thead>
                <tr>
                  <th>S/N</th>
                  <th>Title</th>
                  <th>Expected&nbsp;Amount</th>
                  <th>Amount&nbsp;Processed</th>
                  <th>Fees</th>
                  <th>Employees</th>
                  <th>Run&nbsp;Date</th>
                  <th>Type</th>
                  <th>Status</th>
                  <th>Created</th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  class="batch"
                  v-for="(payroll, index) in paginatedData"
                  :key="index"
                >
                  <td>{{ index + 1 }}</td>
                  <td>{{ payroll.title }}</td>
                  <td>₦{{ formatNumber(payroll.total_amount) }}</td>
                  <td>₦{{ formatNumber(payroll.total_amount_processed) }}</td>
                  <td>₦{{ formatNumber(payroll.total_fees) }}</td>
                  <td>{{ payroll.total_employees }}</td>
                  <td>
                    {{ payroll.day }}, {{ monthToString(payroll.month) }}
                    {{ payroll.year }}.
                  </td>

                  <td>{{ payroll.payroll_type }}</td>
                  <td>{{ payroll.status }}</td>
                  <td>{{ createdDate(payroll) }}</td>
                  <td>
                    <button @click="viewPayouts(payroll.uuid)">
                      Transactions
                    </button>
                  </td>
                  <td>
                    <button
                      v-if="payroll.status === 'PENDING'"
                      @click="managePayroll(payroll.uuid)"
                    >
                      Manage
                    </button>
                    <!-- <div @click="showDetails(payroll)">&#10247;</div> -->
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="paginationContainer">
              <div class="pagination-controls">
                <button
                  class="paginationBtn"
                  @click="prevPage"
                  :disabled="!pagination.prev_page_url"
                >
                  Previous
                </button>
                <span
                  >Page {{ pagination.current_page }} of
                  {{ pagination.last_page }}</span
                >

                <button
                  class="paginationBtn"
                  @click="nextPage"
                  :disabled="!pagination.next_page_url"
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as types from "../../../store/constant";
import PageLoader from "../../partials/page-loader";
import EmptyContent from "../../partials/emptyContent";
import Header from "../../partials/header";
import Sidebar from "../../partials/sidebar";
import BlueLoader from "../../partials/blue-loader";
import Modal from "../../partials/modal.vue";
import loginVue from "../onboard/login.vue";

export default {
  name: "PayrollHistory",
  components: {
    EmptyContent,
    Header,
    Sidebar,
    PageLoader,
    BlueLoader,
    Modal,
  },
  data() {
    return {
      modalVisible: false,
      modalTitle: "",
      modalContent: "",
      selectedPayroll: {},
      item: "payroll",
      payroll: "payroll",
      filter: "all",
      month: "",
      loader: true,
      history: [],
      modal: false,
      status: null,
      paginatedData: [],
      pagination: {
        current_page: null,
        last_page: null,
        next_page_url: null,
        prev_page_url: null,
        itemsPerPage: null,
        totalRecords: null,
        total_page: null,
      },
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(
        this.pagination.totalRecords / this.pagination.itemsPerPage
      );
    },
  },
  created() {
    this.getHistory();
  },
  methods: {
    fetchData(page = 1) {
      const url = `${types.PAYROLL_HISTORY}?page=${page}`;
      this.$http
        .get(url)
        .then((resp) => {
          this.history = resp.data.data.data;
          let data = resp.data.data;
          this.paginatedData = data.data;

          this.pagination = {
            current_page: data.current_page,
            last_page: data.last_page,
            next_page:
              data.current_page < data.last_page ? data.current_page + 1 : null,
            prev_page: data.current_page > 1 ? data.current_page - 1 : null,
            items_per_page: data.per_page,
            total_records: data.total,
          };

          this.loader = false;
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    },
    nextPage() {
      if (this.pagination.next_page_url) {
        this.fetchData(this.pagination.next_page_url);
      }
    },
    prevPage() {
      if (this.pagination.prev_page_url) {
        this.fetchData(this.pagination.prev_page_url);
      }
    },
    getHistory() {
      this.fetchData();
    },
    showDetail(payroll) {
      this.selectedPayroll = payroll;
      this.showModal = true;
    },
    openModal(title, content) {
      this.modalTitle = title;
      this.modalContent = content;
      this.modalVisible = true;
    },

    showDetails(payroll) {
      this.openModal("Payroll Details");
    },

    closeModalVisibility() {
      this.modalVisible = false;
    },

    viewPayouts(uuid) {
      this.$router.push({ name: "payrollDetails", params: { id: uuid } });
    },
    managePayroll(uuid) {
      this.$router.push({
        name: "processPayroll",
        query: { payroll_id: uuid },
      });
    },
    monthToString(number) {
      const months = {
        1: "January",
        2: "February",
        3: "March",
        4: "April",
        5: "May",
        6: "June",
        7: "July",
        8: "August",
        9: "September",
        10: "October",
        11: "November",
        12: "December",
      };

      return months[number] || "Invalid Month";
    },
    createdDate(payrollHistory) {
      const date = new Date(payrollHistory.created_at);
      return date.toLocaleString().split(", ")[0];
    },
    formatNumber(amount) {
      const formatter = new Intl.NumberFormat("en-NG", {
        style: "currency",
        currency: "NGR",
        minimumFractionDigits: 2,
      });

      const amountCheck = amount || 0;

      const v = formatter.format(amountCheck);
      return String(v).substring(4);
    },
    createMonth() {
      const monthArr = [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
      ];
      this.month = monthArr[new Date().getMonth()];
    },

    getMonth() {
      this.loader = true;
      const currentYear = new Date().getFullYear();

      if (this.month && this.month !== "") {
        let params = {
          month: this.month,
          year: currentYear,
        };

        if (this.filter !== "all") {
          params.status = this.filter;
        }

        this.$http
          .get(`${types.PAYROLL_HISTORY}`, { params })
          .then((resp) => {
            this.history = resp.data.data.data;
            this.loader = false;

            for (let index of this.history) {
              index.checkStatus = null;
            }
          })
          .catch((error) => {
            console.error("Error fetching payroll history:", error);
            this.loader = false;
          });
      } else {
        this.loader = false;
      }
    },

    getFilter() {
      const currentMonth = new Date().getMonth() + 1;
      const month = this.month || currentMonth;

      if (this.filter !== "all") {
        this.loader = true;
        this.$http
          .get(`${types.PAYROLL_HISTORY}`, {
            params: {
              month: month,
              status: this.filter,
              year: 2024,
            },
          })
          .then((resp) => {
            this.history = resp.data.data.data;
            this.loader = false;

            for (const index of this.history) {
              index.checkStatus = null;
            }
          })
          .catch((error) => {
            console.error("Error fetching payroll history:", error);
            this.loader = false;
          });
      }
    },
    checkStatus(val) {
      document.querySelectorAll(".show__loader")[val].style.display = "block";
      document.querySelectorAll(".hide__loader")[val].style.display = "none";

      this.$http
        .put(types.PAYOUT_HISTORY_STATUS, {
          payout_id: this.history[val].id,
        })
        .then((resp) => {
          this.status = resp.data.data;
          if (this.status) {
            this.modal = true;
            document.querySelectorAll(".show__loader")[val].style.display =
              "none";
            document.querySelectorAll(".hide__loader")[val].style.display =
              "block";
          }
        })
        .catch(() => {
          document.querySelectorAll(".show__loader")[val].style.display =
            "none";
          document.querySelectorAll(".hide__loader")[val].style.display =
            "block";
        });
    },
    retryPayment(val) {
      document.querySelectorAll(".show__loader")[val].style.display = "block";
      document.querySelectorAll(".hide__loader")[val].style.display = "none";

      this.$http
        .patch(types.PAYOUT_HISTORY_RETRY, {
          payout_id: this.history[val].id,
        })
        .then(() => {
          document.querySelectorAll(".show__loader")[val].style.display =
            "none";
          document.querySelectorAll(".hide__loader")[val].style.display =
            "block";
        })
        .catch(() => {
          document.querySelectorAll(".show__loader")[val].style.display =
            "none";
          document.querySelectorAll(".hide__loader")[val].style.display =
            "block";
        });
    },
    closeModal() {
      this.modal = false;
      this.status = null;
    },
  },
};
</script>
<style lang="scss" scoped>
.paginationContainer {
  margin-top: 20px;
}
.pagination-controls {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-top: 0 auto;
  background: rgb(217, 216, 216);
  margin: 0 auto;
  text-align: center;
  width: 20rem;
}
.paginationBtn {
  padding: 5px 10px;
  background: #fff;
  border-radius: 4px;
}

.filterBtnCover {
  display: flex;
  @media (max-width: 768px) {
    flex-direction: column;
  }
}
.filterBtn {
  background: #fff;
  color: #000;
  padding: 1rem 1rem;
  border: 2px solid #5099de;
  text-align: center;
  margin-left: 0.5rem;
  width: 5rem;
  display: flex;
  justify-content: center;
  align-self: center;
}
.filterSelect {
  padding: 1rem 0;
}
.table-btn {
  background: #000000;
}
.flex {
  display: flex;
}
.dots {
  margin-left: 1rem;
}

.history {
  padding-top: 56px;
  padding-left: 3.125vw;
  padding-right: 3.125vw;

  > p {
    font-size: 1.2rem;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.18;
    letter-spacing: normal;
    text-align: left;
    color: #000000;
    margin: 0;
  }

  > .history__div {
    border-top: 1px solid #caced5;
    padding: 0 5px;

    > .history__div--loader {
      width: 55px;
      margin: 20px auto;
    }

    > .history__div--content {
      margin-top: 30px;
      margin-bottom: 100px;
      padding: 40px 35px;

      .history__div--content-filter {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: space-between;
        align-content: center;
        margin-bottom: 50px;

        > div {
          width: 35%;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: center;
          align-content: center;

          > .history__div--content-filter-label {
            width: 50%;
            > span {
              font-size: 1.3rem;
              font-weight: normal;
              font-style: normal;
              font-stretch: normal;
              line-height: 1.17;
              letter-spacing: normal;
              text-align: left;
              color: #707070;
            }
          }

          > .history__div--content-filter-input {
            width: 60%;
            height: 40px;
            border: solid 1px #caced5;
            background-color: #ffffff;

            @media (max-width: 768px) {
              width: 5rem;
              margin-left: 0.3rem;
            }

            > select {
              width: 100%;
              height: 40px;
              border: 0;
              outline: 0;
            }
          }
        }
      }

      > .history__div--content-err {
        text-align: center;
        color: red;
        font-size: 1rem;
        font-style: italic;
        margin-top: 10px;
      }
    }
  }
}

.history__modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);

  > .history__modal--cover {
    max-width: 500px;
    padding: 0 10px;
    margin: 50px auto;

    > .history__modal--content {
      background-color: #fff;
      padding: 20px;
      border-radius: 5px;

      > div {
        overflow: hidden;

        > div {
          width: 100px;
          cursor: pointer;
          margin: 20px auto 0 auto;
          background-color: #5099de;
          border-radius: 5px;
          text-align: center;
          color: #fff;
          font-size: 1.2rem;
          padding: 8px 0;
        }
      }

      > h5 {
        text-align: center;
        color: #5099de;
      }

      > p {
        text-align: center;
      }
    }
  }
}

.table-form {
  margin-top: 20px;
  padding-bottom: 15px;
  @media (max-width: 768px) {
    overflow: scroll;
  }

  table {
    border-collapse: separate;
    border-spacing: 0 1em;

    thead th {
      border: none;
      line-height: 2px;
      font-size: 1rem;
    }
    tr > th:first-child {
      padding-left: 40px;
      padding-right: 0px;
    }
    tbody tr:first-child > td {
      border-top: 3px solid #5099de;
    }

    tr > td:first-child {
      padding-left: 42px;
      padding-right: 0px;
    }
    tr > td:last-of-type {
      padding-right: 60px;
    }

    tr > th:nth-of-type(2) {
      padding-right: 50px;
      padding-left: 0px;
    }
    tr > td:nth-of-type(2) {
      padding-right: 50px;
      padding-left: 0px;
    }
    tr > th:nth-of-type(4) {
      padding-right: 50px;
      padding-left: 20px;
    }

    tr > td:nth-of-type(4) {
      padding-right: 50px;
      padding-left: 20px;
    }
    tr > th:nth-of-type(5) {
      padding-left: 30px;
    }
    tr > td:nth-of-type(5) {
      padding-left: 30px;
    }
    th {
      width: 20%;
      font-size: 1rem;
    }
    input {
      border: none;
    }
    td {
      width: 20%;
      padding-top: 17px;
      font-size: 1rem;
    }
    tr.batch {
      height: 60px;
      border-radius: 2px;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
      background-color: #ffffff;
      font-weight: 500;
      font-size: 1rem;
      color: #000;
      button {
        font-size: 0.8rem;
        background: #5099de;
        width: auto;
        padding: 0 10px;

        border-radius: 5px;
        box-shadow: rgba(0, 0, 0, 0.1) 0 2px 4px;
        color: #ffffff;
        cursor: pointer;
        font-family: Inter, -apple-system, system-ui, Roboto, "Helvetica Neue",
          Arial, sans-serif;
        line-height: 34px;
        outline: 0;
        overflow: hidden;
        pointer-events: auto;
        position: relative;
        text-align: center;
        touch-action: manipulation;
        user-select: none;
        -webkit-user-select: none;
        white-space: nowrap;
        z-index: 9;
        border: 0;
        flex: 0 0 auto;
      }
      span {
        font-weight: normal;
        font-size: 13px;
        padding: 8px;
        color: #fff !important;
      }
    }
  }
}
</style>
